import React from 'react';
import { motion } from 'framer-motion';
export const Cta = () => {
  return <section id="cta" className="bg-[#0A0A0A] py-40 flex flex-col items-center text-center px-6 border-t border-gold/10" data-id="element-29">
      <div className="max-w-2xl" data-id="element-30">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-4xl text-gold tracking-[0.2em] uppercase mb-8 font-light" data-id="element-31">
          Tu Transformación
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="font-sans font-light text-offwhite/70 text-sm md:text-base mb-16 leading-relaxed" data-id="element-32">
          Reservá tu turno directo por WhatsApp. Sin vueltas, sin listas de
          espera interminables.
        </motion.p>

        <motion.button initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} whileHover={{
        backgroundColor: '#C9A84C',
        color: '#0A0A0A'
      }} className="border border-gold text-gold px-12 py-4 transition-colors font-sans text-xs tracking-[0.2em] uppercase" data-id="element-33">
          Escribime por WhatsApp
        </motion.button>
      </div>
    </section>;
};